<template>
  <div>
    <div
      :id="nameDoomNode"
      :style="'overflow: hidden;position: relative; height:' + height"
    ></div>
  </div>
</template>

<script>
import * as echarts from "echarts/core";
import { TitleComponent, TooltipComponent, LegendComponent } from "echarts/components";
import { PieChart } from "echarts/charts";
import { LabelLayout } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
import { v4 as uuidv4 } from "uuid";

echarts.use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout,
]);

export default {
  name: "PieChart",
  props: {
    data: {
      type: Array,
      required: true,
    },
    tipo: {
      type: String,
      required: true,
    },
    colors: {
      type: Array,
      required: true,
    },
    height: {
      type: String,
      required: true,
    },
    legendShow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    formatAsCurrency: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nameDoomNode: "content-" + uuidv4(),
      myChart: null,
    };
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN'
      }).format(value);
    },
  },
  watch: {
    data(newData, oldData) {
      if (this.myChart && newData !== oldData) {
        this.myChart.setOption({
          series: [{ data: newData }],
        });
      }
    },
  },
  mounted() {
    const dom = document.getElementById(this.nameDoomNode);
    this.myChart = echarts.init(dom, null, {
      renderer: "svg",
      useDirtyRect: false,
    });

    const option = {
      title: {
        text: this.title,
        left: "center",
        textStyle: {
          fontSize: "10px",
        },
      },
      textStyle: {
        fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif',
      },
      tooltip: {
        trigger: "item",
        formatter: (params) => {
          const value = this.formatAsCurrency 
            ? this.formatCurrency(params.value)
            : params.value;
          return `${params.name}: ${value} (${params.percent}%)`;
        },
      },
      legend: {
        orient: "horizontal",
        left: "left",
        show: this.legendShow,
      },
      series: [
        {
          name: this.tipo,
          type: "pie",
          radius: "65%",
          center: ["50%", "50%"],
          color: this.colors,
          data: this.data,
          label: {
            show: true,
            formatter: (param) => {
              const value = this.formatAsCurrency 
                ? this.formatCurrency(param.value)
                : param.value;
              return param.name + ". " + value + " ";
            },
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };

    this.myChart.setOption(option);

    this.myChart.on("click", (params) => {
      if (params.name) {
        this.$emit("chart-click", {
          selectedValue: params.name,
          _id: params.data._id,
          tipe: this.tipo,
        });
      }
    });

    window.addEventListener("resize", this.myChart.resize);
  },
};
</script>
